import React from 'react'
import PropTypes from 'prop-types'
import AjaxLoader from './AjaxLoader'
import globals from '../globals'
import Button from '../elements/Button'

class ModuleWithLoader extends React.Component {
    componentDidMount () {
        if (this.props.isLoaded && !this.props.hasError) {
            globals.animatePageIn(this.container)
        }
    }

    componentDidUpdate (prevProps) {
        if (prevProps.isLoaded !== this.props.isLoaded && !this.props.hasError) {
            globals.animatePageIn(this.container)
        }
    }

    reload (event) {
        event.preventDefault()
        window.location.reload()
    }

    render () {
        const MinHeightLoader = <div className='loader-min-height'><AjaxLoader /></div>
        const Error = (
            <div className='row'>
                <div className='col-12 text-center pb-2'>
                    <h2>Oops!</h2>
                    <p>Something went wrong and we were unable to process your request. Please try again shortly.</p>
                    <Button title='Try again' action={this.reload.bind(this)} />
                </div>
            </div>
        )

        return (
            <div className={`module-inner ${this.props.className ? this.props.className : ''}`}>
                {!this.props.isLoaded ? MinHeightLoader : ''}
                {this.props.hasError
                    ? Error
                    : <div ref={el => this.container = el} style={{ opacity: 0 }}>
                        {this.props.children}
                      </div>}
            </div>
        )
    }
}

ModuleWithLoader.propTypes = {
    isLoaded: PropTypes.bool.isRequired,
    hasError: PropTypes.bool,
    className: PropTypes.string
}

export default ModuleWithLoader



// WEBPACK FOOTER //
// ./resources/js/components/ModuleWithLoader.js